import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { useAllContext } from '../context/AllContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { IoMdClose, IoMdRefresh } from "react-icons/io";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaDice, FaPause, FaPlay } from 'react-icons/fa';
import { IoArrowForwardOutline } from "react-icons/io5";

const LiveEventBattle = () => {
    const { i18n } = useTranslation()

    const limitsUser = JSON.parse(localStorage.getItem('limitsUser'));
    const params = useParams()

    const { getAllBattle, allBattle } = useAllContext()

    const [liveBattle, setLiveBattle] = useState({});
    const [currentView, setCurrentView] = useState("default"); // "default" | "next"

    const battles = allBattle?.battles || [];

    // 🔹 find types of battles
    const liveBattleFind = battles.find(b => b.battle_status === "live");
    const nextBattle = battles.find(b => b.battle_status === null);
    const completedBattles = battles.filter(b => b.battle_status === "complete");
    const lastCompletedBattle =
        completedBattles.length > 0
        ? completedBattles[completedBattles.length - 1]
        : null;

    // 🔹 set which battle to show
    useEffect(() => {
        // If currentView === "next", we already set liveBattle manually
        if (currentView !== "next") {
            if (liveBattleFind) {
                setLiveBattle(liveBattleFind);
            } else if (lastCompletedBattle) {
                setLiveBattle(lastCompletedBattle);
            } else {
                setLiveBattle({});
            }
        }
    }, [liveBattleFind, lastCompletedBattle]);

    // 🔹 handle next button click
    const handleNextBattle = () => {
        if (nextBattle) {
            setLiveBattle(nextBattle); // direct update
            setCurrentView("next");    // mark current view
        } else {
            toast.warning("No next battle available!");
        }
        document.getElementById('offcanvasEvent').querySelector('.btn-close').click();
    };

    // const [liveBattle, setLiveBattle] = useState({});
    // const liveBattleFind = allBattle && allBattle.battles && allBattle?.battles.find(battle => battle.battle_status === "live");
    // const liveBattleFindNext = allBattle && allBattle.battles && allBattle?.battles.find(battle => battle.battle_status === null);

    // useEffect(() => {
    //     if (liveBattleFind) {
    //         setLiveBattle(liveBattleFind);
    //     } else if (liveBattleFindNext) {
    //         setLiveBattle(liveBattleFindNext);
    //     } else {
    //         setLiveBattle({});
    //     }
    // }, [liveBattleFind, liveBattleFindNext])


    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [milliseconds, setMilliseconds] = useState(0);

    const [countdowns, setCountdowns] = useState({});
    useEffect(() => {
        if (liveBattle && allBattle) {
            let endTime;

            // Case 1: Ongoing without pause
            if (
                liveBattle.battle_time_status === "play" &&
                liveBattle.battle_time_pause === null &&
                liveBattle.battle_status === "live"
            ) {
                const startTime = new Date(liveBattle.battle_time_start);
                endTime = new Date(
                    startTime.getTime() + (allBattle?.battles_time || 0) * 60000
                );
            }

            // Case 2: Resumed after pause
            if (
                liveBattle.battle_time_status === "play" &&
                liveBattle.battle_time_pause !== null &&
                liveBattle.battle_timeRemaining !== null &&
                liveBattle.battle_status === "live"
            ) {
                const startTimeReplay = new Date(liveBattle.battle_time_replay);

                // ✅ Safe regex match
                const match = liveBattle.battle_timeRemaining?.match(/\d+/g) || [];
                const minutes = parseInt(match[0] || "0", 10);
                const seconds = parseInt(match[1] || "0", 10);
                const battleTimeRemaining = minutes * 60000 + seconds * 1000;

                endTime = new Date(startTimeReplay.getTime() + battleTimeRemaining);
            }

            if (endTime) {
                const updateTimer = () => {
                    const now = new Date();
                    const timeDiff = endTime - now;

                    if (timeDiff > 0) {
                        const mins = Math.floor((timeDiff / 1000 / 60) % 60);
                        const secs = Math.floor((timeDiff / 1000) % 60);
                        const millis = Math.floor((timeDiff % 1000) / 100);

                        // Update local states
                        setMinutes(mins);
                        setSeconds(secs);
                        setMilliseconds(millis);

                        // ✅ Update countdown text state
                        setCountdowns((prev) => ({
                            ...prev,
                            [liveBattle._id]: `${mins}m ${secs}s`,
                        }));
                    } else {
                        // Time’s up
                        setMinutes(0);
                        setSeconds(0);
                        setMilliseconds(0);

                        setCountdowns((prev) => ({
                            ...prev,
                            [liveBattle._id]: "Time is up!",
                        }));

                        clearInterval(intervalId);
                    }
                };

                const intervalId = setInterval(updateTimer, 100);
                updateTimer(); // Run immediately

                return () => clearInterval(intervalId);
            }
        }
    }, [allBattle, liveBattle]);


    const [votingStatus, setVotingStatus] = useState({});
    const getVotingStatus = async () => {
        const apiData = {
            eventId: params.eventId,
            battleId: liveBattle?._id,
            vote_send_userId: limitsUser?._id
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/VotingStatusActive`, apiData, {
                headers: {
                    Authorization: `${limitsUser?.token}`
                }
            })
            const data = await response.data

            if (data.status === 0) {
                // toast.error(data.message)
            }

            if (data.status === 1) {
                toast.success(data.message)
                setVotingStatus(data)
            } else {
                setVotingStatus({})
            }

        } catch (error) {
            console.log('Error:', error?.response?.data?.message);
            toast.error(error?.response?.data?.message)
        }
    }

    const totalVotes = (votingStatus?.Player1 || 0) + (votingStatus?.Player2 || 0);
    const player1Percentage = totalVotes ? ((votingStatus?.Player1 / totalVotes) * 100).toFixed(2).replace(/\.?0+$/, '') : 0;
    const player2Percentage = totalVotes ? ((votingStatus?.Player2 / totalVotes) * 100).toFixed(2).replace(/\.?0+$/, '') : 0;


    const [reduceTime, setReduceTime] = useState({
        reduceMinutes: "",
        reduceSeconds: ""
    })

    const [reduceErrors, setReduceErrors] = useState({})
    const reduceValidate = (btStatus) => {
        let errors = {};

        if (btStatus === "replay") {
            if (!reduceTime.reduceMinutes || !reduceTime.reduceSeconds) {
                errors.time = "Time is required";
            }
        }
        return errors;
    };

    const setTimeFun = () => {
        document.getElementById('offcanvasEvent').querySelector('.btn-close').click()
        if (liveBattle?.battle_timeRemaining) {
            const time = liveBattle.battle_timeRemaining;

            if (time === "Time is up!") {
                setReduceTime({
                    reduceMinutes: "00",
                    reduceSeconds: "00"
                });
                return;
            }

            const [minPart, secPart] = time.split(" ");
            const minutes = minPart.replace("m", "").padStart(2, "0");
            const seconds = secPart.replace("s", "").padStart(2, "0");

            setReduceTime({
                reduceMinutes: minutes,
                reduceSeconds: seconds
            });
        }
    }

    const submitBattleTime = async (eventId, battlesId, btStatus) => {
        const formErrors = reduceValidate(btStatus);
        setReduceErrors(formErrors);

        const apiData = {
            eventId: eventId,
            battleId: battlesId,
            battle_time_start: new Date(),
            bt_status: btStatus,
            reduce_time: btStatus === "replay" ? `${reduceTime.reduceMinutes}:${reduceTime.reduceSeconds}` : "",
        }

        if (Object.keys(formErrors).length === 0) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin-api/EventSingleBattleTimeStart`, apiData, {
                    headers: {
                        Authorization: `${limitsUser?.token}`
                    }
                })
                const data = await response.data

                if (data.status === 0) {
                    toast.error(data.message)
                }

                if (data.status === 1) {
                    toast.success(data.message)
                    getAllBattle(params.eventId);
                    document.getElementById('offcanvasEvent').querySelector('.btn-close').click()
                    if (btStatus === "replay") {
                       setReduceTime({
                            reduceMinutes: "",
                            reduceSeconds: ""
                        })
                        document.getElementById('replayModal').querySelector('.btn-close').click()
                    }
                }

            } catch (error) {
                console.log('Error:', error?.response?.data?.message);
                toast.error(error?.response?.data?.message)
            }
        }
    }

    const battleTimePause = async (eventId, battlesId) => {
        const apiData = {
            eventId: eventId,
            battleId: battlesId,
            battle_time_pause: new Date(),
            battle_timeRemaining: countdowns[battlesId]
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin-api/EventSingleBattleTimePause`, apiData, {
                headers: {
                    Authorization: `${limitsUser?.token}`
                }
            })
            const data = await response.data

            if (data.status === 0) {
                toast.error(data.message)
            }

            if (data.status === 1) {
                toast.success(data.message)
                getAllBattle(params.eventId);
                document.getElementById('offcanvasEvent').querySelector('.btn-close').click()
            }

        } catch (error) {
            console.log('Error:', error?.response?.data?.message);
            toast.error(error?.response?.data?.message)
        }
    }

    useEffect(() => {
        if (liveBattle?._id) {
            getVotingStatus()
        }
    }, [liveBattle])

    useEffect(() => {
        // getAllBattle(params.eventId)

        // Set up an interval to fetch data every second (1000ms)
        const intervalId = setInterval(() => {
            getAllBattle(params.eventId);
        }, 1000);

        // Cleanup the interval on component unmount
        return () => clearInterval(intervalId);
    }, [params.eventId])
    
    return (
        <>
            <div className='main-content p-0 liveevent-content battleclub-content' style={{"background": "#111010"}}>
                {liveBattle && Object.keys(liveBattle).length > 0 ?
                    <div className='padding2 live-section h-100'>
                        <div className='container-fluid h-100'>
                            <div className='row gx-2 text-center border-bottom  pb-3'>
                                <div className='col-md-4 col-5'>
                                    <div className="d-flex align-items-center">
                                        <div className='me-4'>
                                            {liveBattle?.battle1?.profileImage ?
                                                liveBattle?.battle1?.profileImage.includes('google') ? <img src={`${liveBattle.battle1.profileImage}`} className='img-fluid rounded-circle' alt="" style={{ 'width': '80px', 'minWidth': '80px', 'height': '80px', "objectFit": "cover" }} />
                                                    : <img src={`${process.env.REACT_APP_IMAGES_URL}/${liveBattle.battle1.profileImage}`} crossOrigin="anonymous" className='img-fluid rounded-circle' alt="" style={{ 'width': '80px', 'minWidth': '80px', 'height': '80px', "objectFit": "cover" }} />
                                                : <img src={require('../assets/images/user-img.png')} className='img-fluid rounded-circle' alt="" style={{ 'width': '80px', 'minWidth': '80px', 'height': '80px', "objectFit": "cover" }} />
                                            }
                                        </div>
                                        <div>
                                            <h6 className='mb-0 text-white display-5 fw-semibold'>{liveBattle?.battle1?.username}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4 col-2 align-self-center'>
                                    <div className="progress progress1 border-0 position-relative">
                                        <h3 className='text-uppercase vote-txt'>Vote</h3>
                                        <div className="progress-bar" role="progressbar" style={{ "width": `${player1Percentage}%`, "background": "#0F78C5" }} aria-valuenow={player1Percentage} aria-valuemin="0" aria-valuemax="100"></div>
                                        <div className="progress-bar" role="progressbar" style={{ "width": `${player2Percentage}%`, "background": "#C12768" }} aria-valuenow={player2Percentage} aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                                <div className='col-md-4 col-5'>
                                    <div className="d-flex align-items-center justify-content-end">
                                        <div>
                                            <h6 className='mb-0 text-white display-5 fw-semibold'>{liveBattle?.battle2?.username}</h6>
                                        </div>
                                        <div className='ms-4'>
                                            {liveBattle?.battle2?.profileImage ?
                                                liveBattle?.battle2?.profileImage.includes('google') ? <img src={`${liveBattle.battle2.profileImage}`} className='img-fluid rounded-circle' alt="" style={{ 'width': '80px', 'minWidth': '80px', 'height': '80px', "objectFit": "cover" }} />
                                                    : <img src={`${process.env.REACT_APP_IMAGES_URL}/${liveBattle.battle2.profileImage}`} crossOrigin="anonymous" className='img-fluid rounded-circle' alt="" style={{ 'width': '80px', 'minWidth': '80px', 'height': '80px', "objectFit": "cover" }} />
                                                : <img src={require('../assets/images/user-img.png')} className='img-fluid rounded-circle' alt="" style={{ 'width': '80px', 'minWidth': '80px', 'height': '80px', "objectFit": "cover" }} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='live1'>
                                <div className='row gx-3 h-100'>
                                    <div className={`col-md-6 col-12 ${liveBattle?.battle1?._id === liveBattle?.player_winner_id ? "win_box" : ""}`}>
                                        <div className='card card1 h-100 bg-transparent border-0'>
                                            <div className='card-body'>

                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-md-6 col-12 ${liveBattle?.battle2?._id === liveBattle?.player_winner_id ? "win_box" : ""}`}>
                                        <div className='card card1 h-100 bg-transparent border-0'>
                                            <div className='card-body'>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row gx-2 border-bottom border-top'>
                                <div className='col-md-4 col-5 border-end'>
                                    {
                                        liveBattle?.battle_time_status === null || liveBattle?.battle_time_status === "play" ?
                                            <h4 className='display-3 fw-semibold mb-0'>
                                                <span className='d-inline-block me-1'>{String(minutes).padStart(2, '0')}</span>:
                                                <span className='d-inline-block' style={{ "minWidth": "65px" }}>{seconds < 10 ? '0' : ''}{seconds}</span>.
                                                <span className="d-inline-block small" style={{ "minWidth": "60px" }}>{String(milliseconds).padStart(2, '0')}</span>
                                            </h4>
                                            : <h4 className='display-3 fw-semibold mb-0'>{liveBattle?.battle_timeRemaining}</h4>
                                    }
                                </div>
                                <div className='col-md-4 col-2 align-self-center'>
                                    <h4 className='fw-bold text-center'>
                                        {
                                            i18n.language === 'en' ? <div className='d-flex justify-content-center'>
                                                <span className='display-6 fw-semibold'>{liveBattle?.battle1_keyword_eng}</span>
                                                <span className='fw-medium mx-4'>Theme<br /><IoMdClose /></span>
                                                <span className='display-6 fw-semibold'>{liveBattle?.battle2_keyword_eng}</span>
                                            </div>
                                                : <div className='d-flex justify-content-center'>
                                                    <span className='display-6 fw-semibold'>{liveBattle?.battle1_keyword_jap}</span>
                                                    <span className='fw-medium mx-4'>Theme<br /><IoMdClose /></span>
                                                    <span className='display-6 fw-semibold'>{liveBattle?.battle2_keyword_jap}</span>
                                                </div>
                                        }
                                    </h4>
                                </div>
                                <div className='col-md-4 col-5 border-start'>
                                    {
                                        liveBattle?.battle_time_status === null || liveBattle?.battle_time_status === "play" ?
                                            <h4 className='display-3 fw-semibold text-end mb-0'>
                                                <span className='d-inline-block me-1'>{String(minutes).padStart(2, '0')}</span>:
                                                <span className='d-inline-block' style={{ "minWidth": "65px" }}>{seconds < 10 ? '0' : ''}{seconds}</span>.
                                                <span className="d-inline-block small" style={{ "minWidth": "60px" }}>{String(milliseconds).padStart(2, '0')}</span>
                                            </h4>
                                            : <h4 className='display-3 fw-semibold text-end mb-0'>{liveBattle?.battle_timeRemaining}</h4>
                                    }
                                </div>
                            </div>
                            <div className='row gx-3 align-items-center py-4'>
                                <div className='col-md-4 col-12'>
                                    <img src={require('../assets/images/battle_club_logo.PNG')} className='img-fluid logo1' alt="" style={{ "height": "120px" }} />
                                </div>
                                <div className='col-md-4 col-12 mx-auto text-center'>
                                    {/* <h4 className='mb-0 text-white text-center display-5 fw-semibold'>{allBattle?.roulette?.theme}</h4> */}
                                    <img src={`${process.env.REACT_APP_IMAGES_URL}/${allBattle?.roulette?.sponsor_img}`} crossOrigin="anonymous" className='img-fluid logo1' alt="" style={{ "maxHeight": "100px" }} />
                                    {/* <h4 className='mb-0 text-white text-center display-5 fw-semibold'>Battle Started!</h4> */}
                                    {/* <hr className='opacity-100' />
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className='d-flex align-items-center me-3'>
                                            <img src={require('../assets/images/battle_club_logo.PNG')} className='img-fluid logo1 me-3' alt="" style={{ "height": "55px" }} />
                                            <h4 className='mb-0 text-white fw-medium'>{i18n.language === 'en' ? allBattle?.title_eng : allBattle?.title_jap}</h4>
                                        </div>
                                        <div>
                                            <h4 className='mb-0 text-white text-center fw-medium'>{liveBattle?.battle_name}</h4>
                                        </div>
                                    </div> */}
                                </div>
                                <div className='col-md-4 col-12 align-self-end text-end'>
                                    <img src={require('../assets/images/battle_club_logo.PNG')} className='img-fluid logo1 me-3' alt="" style={{ "height": "120px" }} />
                                    <Link className="fs-1 align-bottom" data-bs-toggle="offcanvas" data-bs-target="#offcanvasEvent" aria-controls="offcanvasEvent"><BsThreeDotsVertical /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <div className='text-center w-100 vh-100 d-flex flex-column justify-content-center'>
                        <h4 className='display-1 fw-semibold text-center mb-0'>Please wait for the next battle</h4>
                    </div>
                }

            </div>

            <div className="offcanvas offcanvas1 offcanvas-bottom" tabIndex="-1" id="offcanvasEvent" aria-labelledby="offcanvasEventLabel">
                <div className="offcanvas-header">
                    <h5 id="offcanvasEventLabel"></h5>
                    <button type="button" className="btn-close text-reset btn-close-white fs-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    <ul className="nav nav3 justify-content-around justify-content-center">
                        {
                            allBattle?.roulette !== null ? <Link
                                to={`/roulette-public/${params.eventId}/${liveBattle?._id}`}
                                className="nav-link"
                                onClick={() => {
                                    document.getElementById('offcanvasEvent').querySelector('.btn-close').click()
                                }}
                            >
                                <FaDice className="me-3" /> Roulette
                            </Link>
                                : <Link to={``} className="nav-link" onClick={() => { toast.warning("Please select roulette theme") }}><FaDice className="me-3" /> Roulette</Link>
                        }

                        {
                            allBattle?.roulette !== null ?
                                liveBattle?.battle1_keyword_eng !== null ?
                                    liveBattle?.battle_time_status === null && liveBattle?.battle_time_replay === null ? <Link className='nav-link' onClick={() => { submitBattleTime(params.eventId, liveBattle?._id, "") }}><FaPlay className='me-3' /> Start/Pause</Link>
                                        : liveBattle?.battle_time_status === "pause" ? <Link to={``} className="nav-link"
                                                                                            data-bs-toggle="modal" data-bs-target="#replayModal"
                                                                                            onClick={setTimeFun}
                                                                                            style={{ "minWidth": "auto" }}><FaPlay className='me-3' /> Start/Pause
                                                                                        </Link>
                                            : liveBattle?.battle_timeRemaining === "Time is up!" ? <Link className='nav-link' onClick={() => { toast.warning("Time is up!") }}><FaPlay className='me-3' /> Start/Pause</Link>
                                                : <Link to={``} className="nav-link" onClick={() => { battleTimePause(params.eventId, liveBattle?._id) }}><FaPause className='me-3' /> Start/Pause</Link>
                                    : <Link to={``} className="nav-link" onClick={() => { toast.warning("Please select Keywords") }}><FaPlay className='me-3' /> Start/Pause</Link>
                                : <Link to={``} className="nav-link" onClick={() => { toast.warning("Please select roulette theme") }}><FaPlay className='me-3' /> Start/Pause</Link>
                        }
                        {/* <Link className='nav-link' onClick={() => { submitBattleTime(params.eventId, liveBattle?._id, "replay") }}><FaPlay className='me-3' /> Start/Pause</Link> */}

                        {
                            allBattle?.roulette !== null ?
                                liveBattle?.battle1_keyword_eng !== null ? <Link to={``} className="nav-link" onClick={() => { submitBattleTime(params.eventId, liveBattle?._id, "") }}><IoMdRefresh className='me-3' /> Restart</Link>
                                    : <Link to={``} className="nav-link" onClick={() => { toast.warning("Please select Keywords") }}><IoMdRefresh className='me-3' /> Restart</Link>
                                : <Link to={``} className="nav-link" onClick={() => { toast.warning("Please select roulette theme") }}><IoMdRefresh className='me-3' /> Restart</Link>
                        }

                        <Link
                            to={``}
                            className={`nav-link`}
                            onClick={() => {
                                if (liveBattle?.battle_status === "live" || liveBattle?.battle_status === null) {
                                    toast.warning("A battle is currently live! You can access the next battle after it completes.");
                                } else {
                                    handleNextBattle();
                                }
                            }}
                        >
                            <IoArrowForwardOutline className="me-3" /> Next Battle
                        </Link>

                    </ul>
                </div>
            </div>

            {/* <!-- Modal replay --> */}
            <div className="modal modal1 fade" id="replayModal" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog" style={{ 'maxWidth': '600px' }}>
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0 pt-4 px-4">
                            {/* <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5> */}
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body p-4 p-md-5">
                            <div className='w-100 mx-auto'>
                                <h4 className='mb-5 text-center'>Set Timer</h4>
                                <form className="form form1">
                                    <div className='mb-3 w-100 mx-auto' style={{maxWidth: "250px"}}>
                                        {/* <label className='form-label text-white'>Type</label> */}
                                        <div className='d-flex align-items-center'>
                                            <select
                                                className="form-select"
                                                name="reduceMinutes"
                                                value={reduceTime.reduceMinutes}
                                                onChange={(e) =>
                                                    setReduceTime({
                                                        ...reduceTime,
                                                        [e.target.name]: e.target.value
                                                    })
                                                }
                                            >
                                                <option value="" disabled>MM</option>
                                                {Array.from({ length: 60 }, (_, i) => (
                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                        {String(i).padStart(2, "0")}
                                                    </option>
                                                ))}
                                            </select>

                                            <span className='px-2'>:</span>

                                            <select
                                                className="form-select"
                                                name="reduceSeconds"
                                                value={reduceTime.reduceSeconds}
                                                onChange={(e) =>
                                                    setReduceTime({
                                                        ...reduceTime,
                                                        [e.target.name]: e.target.value
                                                    })
                                                }
                                            >
                                                <option value="" disabled>SS</option>
                                                {Array.from({ length: 60 }, (_, i) => (
                                                    <option key={i} value={String(i).padStart(2, "0")}>
                                                        {String(i).padStart(2, "0")}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {reduceErrors.time && <p className="error-text">{reduceErrors.time}</p>}
                                    </div>
                                </form>

                                <div className='text-center mt-5'>
                                    <button type='button' className='btn btn1' onClick={() => { submitBattleTime(params.eventId, liveBattle?._id, "replay") }}>Start</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LiveEventBattle
